import * as React from 'react';

import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from '../../utils';

// =============================================================================
// Popover Root
// =============================================================================

const Popover = PopoverPrimitive.Root;

// =============================================================================
// Popover Trigger
// =============================================================================

const PopoverTrigger = PopoverPrimitive.Trigger;

// =============================================================================
// Popover Anchor
// =============================================================================

const PopoverAnchor = PopoverPrimitive.Anchor;

// =============================================================================
// Popover Content
// =============================================================================

export interface PopoverContentProps extends React.ComponentPropsWithoutRef<
  typeof PopoverPrimitive.Content
> {
  showArrow?: boolean;
}

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  PopoverContentProps
>(({ className, align = 'center', sideOffset = 4, showArrow = true, children, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-popover min-w-[8rem] overflow-hidden rounded-lg',
        'border border-tkf-line-light bg-tkf-surface text-tkf-fg shadow-xl',
        'data-[state=open]:animate-in data-[state=closed]:animate-out',
        'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
        'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
        'data-[side=bottom]:slide-in-from-top-2',
        'data-[side=left]:slide-in-from-right-2',
        'data-[side=right]:slide-in-from-left-2',
        'data-[side=top]:slide-in-from-bottom-2',
        className
      )}
      {...props}
    >
      {children}
      {showArrow && (
        <PopoverPrimitive.Arrow
          className="fill-[var(--tkf-surface)] drop-shadow-sm"
          width={12}
          height={6}
        />
      )}
    </PopoverPrimitive.Content>
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

// =============================================================================
// Popover Close
// =============================================================================

const PopoverClose = PopoverPrimitive.Close;

// =============================================================================
// Exports
// =============================================================================

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor, PopoverClose };
